// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — index.classic.js, новая — index.cp.js
import { isCp } from 'libs/design';
import * as classic from './index.classic';
import * as cp from './index.cp';

export const AngleDown = isCp ? cp.AngleDown : classic.AngleDown;
export const CalendarInterval = isCp ? cp.CalendarInterval : classic.CalendarInterval;
export const CheckBox = isCp ? cp.CheckBox : classic.CheckBox;
export const ClearFilters = isCp ? cp.ClearFilters : classic.ClearFilters;
export const DoubleZoneInputValueItem = isCp ? cp.DoubleZoneInputValueItem : classic.DoubleZoneInputValueItem;
export const EllipsisItem = isCp ? cp.EllipsisItem : classic.EllipsisItem;
export const Filter = isCp ? cp.Filter : classic.Filter;
export const FilterInputs = isCp ? cp.FilterInputs : classic.FilterInputs;
export const FilterInputsBox = isCp ? cp.FilterInputsBox : classic.FilterInputsBox;
export const FilterSelect = isCp ? cp.FilterSelect : classic.FilterSelect;
export const Input = isCp ? cp.Input : classic.Input;
export const ItemBox = isCp ? cp.ItemBox : classic.ItemBox;
export const Select = isCp ? cp.Select : classic.Select;
export const SelectBox = isCp ? cp.SelectBox : classic.SelectBox;
export const Toggle = isCp ? cp.Toggle : classic.Toggle;
export const ToggleBox = isCp ? cp.ToggleBox : classic.ToggleBox;
export const ZoneInput = isCp ? cp.ZoneInput : classic.ZoneInput;
export const ZoneInputBox = isCp ? cp.ZoneInputBox : classic.ZoneInputBox;
export const ZoneInputValueItem = isCp ? cp.ZoneInputValueItem : classic.ZoneInputValueItem;
export const ZoneInputValueList = isCp ? cp.ZoneInputValueList : classic.ZoneInputValueList;
export const ZoneItem = isCp ? cp.ZoneItem : classic.ZoneItem;
export const ZonePopup = isCp ? cp.ZonePopup : classic.ZonePopup;
export const ZonesList = isCp ? cp.ZonesList : classic.ZonesList;
